export const GET_DEPARTMENTS = 'departments/GET_DEPARTMENTS';
export const GET_DEPARTMENTS_SUCCESS = 'departments/GET_DEPARTMENTS_SUCCESS';
export const GET_DEPARTMENTS_ERROR = 'departments/GET_DEPARTMENTS_ERROR';
